/**
 * 도시 단일 레지스트리 — route id ↔ location 엔티티 ↔ 주야. CityView·StarSystemView·seedCities 공용(drift 방지).
 * 새 도시는 여기 한 줄만 추가하면 라우트·진입·시드가 함께 따라온다.
 */
export interface CitySpec {
  routeId: string; // /worlds/forgium/:cityId
  locId: string; // location 엔티티 id
  planet: string; // 소속 행성 id
  night: boolean; // 주야(렌더 톤)
}

export const CITIES: CitySpec[] = [
  { routeId: 'sigma', locId: 'loc-sigma', planet: 'forgium', night: false },
  { routeId: 'neoncity', locId: 'loc-neoncity', planet: 'forgium', night: true },
];

export const cityByRoute = (planet: string, routeId: string): CitySpec | undefined =>
  CITIES.find((c) => c.routeId === routeId && c.planet === planet);
export const cityByLoc = (locId: string): CitySpec | undefined => CITIES.find((c) => c.locId === locId);

// public 시드 경로(단일 진실 — seedCities·CityView 폴백 공용). export assets가 없거나 손상되어도 도시 아트가 뜬다.
export const cityAlbedoPath = (routeId: string): string => `/cities/${routeId}.png`;
export const cityDepthPath = (routeId: string): string => `/cities/${routeId}-depth.png`;
